

export const itpErrorsDictionary = {
    cc: 'Comunidad autónoma',
    ccaaId: 'Comunidad autónoma',
    enrollmentDate: 'Fecha de matriculación',
    fuel: 'Tipo de motor',
    brand: 'Marca',
    modelo: 'Modelo',
    'Bad Request': 'Comprueba los campos',
}